export default "__VITE_ASSET__DRrOrUol__"